import React, { useState } from 'react';
import { ThemeProvider, Toastr } from '@sparrowengg/twigs-react';
import './App.css';
import config from "../src/twigs.config";
import { useSelector } from 'react-redux';
import Home from './Pages/Home';
import EnvironmentSelector from './components/EnvironmentSelector';

function App() {
  const [refreshKey, setRefreshKey] = useState(0);
  const environmentSelected = useSelector(state => !!state.environment.selectedEnvironment);
  const [environments, setEnvironments] = useState({});

  const handleEnvironmentSelected = (endpoint, environmentName) => {
    setRefreshKey(prev => prev + 1); // Force refresh of Home component
  };

  const handleEnvironmentCleared = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <ThemeProvider theme={config.theme.extend}>
      <Toastr duration={3000} />
      {environmentSelected ? (
        <Home 
          key={refreshKey} 
          onEnvironmentCleared={handleEnvironmentCleared} 
          environments={environments} 
          setEnvironments={setEnvironments} 
        />
      ) : (
        <EnvironmentSelector 
          onEnvironmentSelected={handleEnvironmentSelected} 
          environments={environments} 
          setEnvironments={setEnvironments} 
        />
      )}
    </ThemeProvider>
  );
}

export default App;
